import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";

// Public Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Media from "./pages/Media";
import YouTube from "./pages/YouTube";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Shop from "./pages/Shop";
import ShopSuccess from "./pages/ShopSuccess";
import ProductDetail from "./pages/ProductDetail";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminContent from "./pages/admin/AdminContent";
import AdminYouTube from "./pages/admin/AdminYouTube";
import AdminShop from "./pages/admin/AdminShop";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminLightbox from "./pages/admin/AdminLightbox";
import AdminFanQuestions from "./pages/admin/AdminFanQuestions";

// Layout
import Layout from "./components/Layout";
import AdminLayout from "./components/AdminLayout";

function App() {
  return (
    <div className="min-h-screen bg-demolition-black">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/media" element={<Media />} />
            <Route path="/youtube" element={<YouTube />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:slug" element={<EventDetail />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/p/:slug" element={<ProductDetail />} />
            <Route path="/shop/success" element={<ShopSuccess />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/events" element={<AdminEvents />} />
            <Route path="/admin/content" element={<AdminContent />} />
            <Route path="/admin/youtube" element={<AdminYouTube />} />
            <Route path="/admin/shop" element={<AdminShop />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/lightbox" element={<AdminLightbox />} />
            <Route path="/admin/fan-questions" element={<AdminFanQuestions />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
